document.addEventListener("DOMContentLoaded", function() {
    var searchTriggers = document.querySelectorAll('.search-trigger');
    var searchPopout = document.getElementById('search-popout');
    var searchInput = document.getElementById('ldog_woo_search_form');

        // Check if searchPopout exists
        if (!searchPopout) {
            return;
        }

    searchTriggers.forEach( function(trigger){
        trigger.addEventListener('click', function(){
            if(searchPopout.classList.contains('hide-search')){
                searchPopout.classList.remove('hide-search');
                searchInput.focus();
            } else {
                searchPopout.classList.add('hide-search');
            }
        });
    });

    document.addEventListener('keydown', ({key}) => {
        if( key === 'Escape'){
            if(!searchPopout.classList.contains('hide-search')){
                searchPopout.classList.add('hide-search');
            }
        }
    });

	document.addEventListener('click', function (event) {

		//if the search menu is active and the click event is not inside the search container and this isn't a search trigger
		if(!searchPopout.classList.contains('hide-search') && !event.target.closest('#search-popout') && !event.target.classList.contains('search-trigger')) {

			//hide it again
			searchPopout.classList.add('hide-search');
		}
	}, false);
});